// extracted by mini-css-extract-plugin
export default {"container":"ShabanRefinements_container__eegum","aside":"ShabanRefinements_aside__C4B4r","title":"ShabanRefinements_title__mclLz"};